import { render } from "./Result.vue?vue&type=template&id=6d154b0e&scoped=true"
import script from "./Result.vue?vue&type=script&lang=js"
export * from "./Result.vue?vue&type=script&lang=js"

import "./Result.vue?vue&type=style&index=0&id=6d154b0e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6d154b0e"

export default script